module.exports = __webpack_public_path__ + "img/yourself.aba64d45.jpg";